<template>
	<div class="home-page menu-bg">
    <Header></Header>
    <div class="drop-down-content">
      <div class="drop-down">
        <div class="drop-down-bottom">
          <div class="one one1" @click="getType('winnerList')">
            <div class="down-a">{{$t('winnerList')}}<span class="dian"></span></div>
          </div>
           <div class="one one1"  @click="getType('buy')">
             <div class="down-a">{{$t('buytitle')}}<span class="dian"></span></div>
           </div>
           <div class="drop-down-list" v-if="isType=='buy'">
             <div class="buy-content ac">
               <div class="title fw7 fs40">
                  {{$t('buytitle2')}}
               </div>
               <div class="font" v-html="$t('buyContent')">
               </div>
             </div>
                 <div class="fen" style="font-size: 0.4rem;" @click="getSendOtp()">
                   {{$t('buyBtn')}}
                 </div>
           </div>
           <div class="one one1" @click="$router.push({path:'/luckyDraw'})">
             <div class="down-a">{{$t('Prize')}}<span class="dian"></span></div>
           </div>
           <div class="one one1" @click="getType('referral')">
             <div class="down-a"><span>{{$t('referral')}}</span><span class="dian"></span></div>
           </div>
           <div class="drop-down-list" v-if="isType=='referral'">
            <Referral></Referral>
           </div>
          <div class="one one1" @click="getType('myAccount')">
            <div class="down-a"><span>{{$t('myAccount')}}</span><span class="dian"></span></div>
          </div>
           <div class="drop-down-list" v-if="isType=='myAccount'">
            <myAccount></myAccount>
           </div>
          <div class="one one2" @click="getType('faq')">
            <div class="down-a">{{$t('FAQs')}}<span class="dian"></span></div>
          </div>
           <div class="drop-down-list" v-if="isType=='faq'">
            <faq></faq>
           </div>
          <div class="one one3" @click="getType('termsAndCondition')">
            <div class="down-a">{{$t('TC')}}<span class="dian"></span></div>
          </div>
           <div class="drop-down-list" v-if="isType=='termsAndCondition'">
            <termsAndCondition></termsAndCondition>
           </div>
         <div class="one one4" @click="getType('language')">
            <div class="down-a">{{$t('language')}}<span class="dian"></span></div>
          </div>
           <div class="drop-down-list" v-if="isType=='language'">
            <language></language>
           </div>
          <div class="one one5" @click="getType('unSubscribe')">
            <div class="down-a">{{$t('UNSUBSCRIBE')}}<span class="dian"></span></div>
<!--            <div class="down-a">{{$t('logout')}}<span class="dian"></span></div>-->
          </div>
          <div class="drop-down-list" v-if="isType=='unSubscribe'">
            <div class="ac">
                <div class="fen sub-bg">
                  {{$t('des2')}}
<!--                  {{$t('logoutDesc')}}-->
                </div>
                <div class="mt50">
                  <button class="btn fw7 btn-green" @click="saveModal()">{{$t('Yes')}}</button>
                  <div class="mt20">
                    <button class="btn fw7 btn-red" @click="getType('unSubscribe')">{{$t('No')}}</button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog ref="buyDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 3rem;">
          <div class="alert-modal" slot="mdBox" >
              <div class="sub-content ac">
                <div class="title fw7 fs40">
                   {{$t('enterOtp')}}
                </div>
                <div class="font">
                   {{$t('enterOtpContent')}}
                </div>
                <div class="input-div" style="margin: 0.1rem 0 0.3rem;">
                  <div class="input-item disflex" style="background: none;box-shadow:2px 2px 0.2rem #bebfbf;width: 100%;">
                    <input class="input-item input" v-model="otp" style="width: 100%;height: 0.8rem;box-shadow:none" placeholder="">
                    <button class="btn btn-red" style="padding: 0 0.1rem;min-height: 0.8rem;line-height:  0.8rem;min-width: 1.6rem;margin-left:5px;font-size: 0.3rem;" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
                  </div>
                </div>
                <div class="ResendTips fs20">
                  {{$t('ResendTips')}}<span @click="getSendOtp()" class="red">{{$t('ResendOTP')}}</span>
                </div>
                <button class="btn btn-blue fw7 mt50" @click="getBuy">{{$t('Confirm')}}</button>
              </div>
          </div>
      </Dialog>
    </div>
	</div>
</template>

<script>
    import Header from '../components/headerTwo'
    import Dialog from '../components/dialog'
    import Referral from './referral'
    import myAccount from './myAccount'
    import faq from './faq'
    import termsAndCondition from './termsAndCondition'
    import language from './language'
    export default {
      name: 'app-header',
      components:{
        Header,Dialog,Referral,myAccount,faq,termsAndCondition,language
      },
      data () {
          return {
            search:'',
            isShow:false,
            isActive:'/',
            isShowMenu:false,
            isLogin:false,
            isEnShow:false,
            isType:'',
            otp:'',
            codeText:'',
            buyButton:false
          }
      },
      mounted() {
        this.codeText = this.$t('getCode')
        if(this.$route.query.url){
          this.isActive = this.$route.query.url
        }else{
          this.isActive = '/'
        }
        if(localStorage.getItem('token')){
          this.isLogin = true
        }
        if(this.$route.query.type === 'luckyDraw'){
          this.$router.replace({path:'/luckyDraw'})
          return
        }
        if(this.$route.query.type === 'myAccount'){
          this.$router.replace({path:'/profile'})
          return
        }
        if(this.$route.query.type){
          this.getType(this.$route.query.type)
        }
       },
      created(){
        let that =this;
        that.buyButton = localStorage.getItem('is_white');
      },
		methods: {
      getType(type){
        if(type === 'winnerList') {
          this.$router.push({path:'/winnerList'})
          return
        }
        if(this.isType==type){
          this.isType = ''
        }else{
          this.isType = type
        }
      },
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	//this.isShow = false;
      	this.$refs.saveDialog.showMaskFun();
      },
      // 弹框保存
      saveModal (){
        let that =this;
        that.$parent.loadModal(true);
        that.$api.post('/api/user/unsubscribe',null,r =>{
        	//that.$parent.returnCode(r,function(){
            that.$utils.alertText(r.msg,80,3000);
            that.$parent.loadModal(false);
            if(r.code==1){
              localStorage.removeItem('token')
              localStorage.removeItem('mobile')
              // this.$router.push({path:'/landingpage',query:{}});
              window.location.href = "/";
            }else{
              this.$refs.saveDialog.closeMask();
            }
          //});
        })
      },
      getSendOtp(){
        let that =this;
        if(this.codeText != this.$t('getCode')){
          that.$utils.alertText(this.$t('pleaseWait'),80,3000);
          return;
        }
        // that.$parent.loadModal(true);
        that.$api.post('/api/user/send_otp',null,r =>{
        	that.$parent.returnCode(r,function(){
            that.$refs.buyDialog.showMaskFun();
            that.$utils.alertText(r.msg,80,3000);
            that.countDown(61,1)
            that.$parent.loadModal(false);
          });
        })
      },
      getBuy (){
        let that =this;
        if(!that.otp){
          that.$utils.alertText(that.$t('enterOtp'),80,3000);
          return;
        }
        let data = {
          'otp':that.otp
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/user/verify_otp',data,r =>{
        	//that.$parent.returnCode(r,function(){
            that.$utils.alertText(r.msg,80,3000);
            that.$parent.loadModal(false);
            if(r.code==1){
              that.$refs.buyDialog.closeMask();
            }else{
            }
          //});
        })
      },
      // 计时
      countDown (miao,type){
      	if(miao === 1){
      		this.codeText = this.$t('getCode');
      		return;
      	}
      	miao--;
      	if(type === 1){
      		this.codeText = miao + "s";
          this.isReturn = false
      	}
      	setTimeout(() =>{
      		this.countDown(miao,type);
      	},1000)
      }
		}
    }
</script>
<style>
  .drop-down-content{}
  .drop-down-list{background: #f5f5f5;margin-bottom: 0.4rem;padding:0.3rem 0 0.8rem}
  .drop-down-bottom .one{background: #acff35;box-shadow: 0.05rem 0.05rem 0.35rem #16e7ef;padding: 0.2rem;margin-bottom: 0.2rem;}
  .drop-down{padding:0.4rem 0.3rem;width:96%;margin: 0 auto;}
  .drop-down-top{border-bottom:3px solid #001f5e;padding-bottom:0.4rem;}
  .span{font-size:0.27rem;}
  .mt20{margin-top:0.2rem;}
  .drop-down-bottom >div{font-size:0.2rem}
  .drop-down-bottom .down-a{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size:0.4rem;
    color: #1229b3;
    font-weight: 700;
    text-transform: uppercase;}
  .dian{
    display:inline-block;
    width: 0;
    height: 0;
    border-top: 0.2rem solid #1229b3;
    border-right: 0.2rem solid transparent;
    border-left: 0.2rem solid transparent;}
  .drop-down-bottom img{margin-right:0.15rem;}
  .sub-bg{height:auto;padding:0.4rem 0.4rem;line-height: 0.6rem;box-shadow: 0.05rem 0.05rem 0.47rem #e0e0e0;font-size: 0.4rem;font-weight: 700;}
  .btn-green{padding:0.2rem 0.2rem;background: #4bbee2;font-size:0.4rem;font-weight: 700;line-height:0.5rem;}
  .btn-red{padding:0.2rem 0.2rem;background: #dd4765;width: auto;height: auto;display: block;margin: 0 auto;font-size:0.4rem;font-weight: 700;line-height:0.5rem;}
</style>



// WEBPACK FOOTER //
// src/page/legacyMenu.vue